import { create } from 'zustand';

// Generate unique tab ID for this session
const getTabId = () => {
    if (!window.tabId) {
        window.tabId = `tab_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
    }
    return window.tabId;
};

// Helper functions for tab-specific localStorage
const getTabStorage = (key) => {
    const tabSpecificKey = `${key}_${getTabId()}`;
    return localStorage.getItem(tabSpecificKey);
};

const setTabStorage = (key, value) => {
    const tabSpecificKey = `${key}_${getTabId()}`;
    if (value === null || value === undefined) {
        localStorage.removeItem(tabSpecificKey);
    } else {
        localStorage.setItem(tabSpecificKey, value);
    }
};

const useGlobalData = create((set, get) => ({
    // Įmonių sąrašas ir pasirinkta įmonė
    selectedCompany: getTabStorage('selectedCompany'),
    setSelectedCompany: (company) => {
        // Handle null, undefined, and empty string as clearing selection
        const normalizedCompany = (company === null || company === undefined || company === '' || company === 'all') ? null : company;
        setTabStorage('selectedCompany', normalizedCompany);
        set({ selectedCompany: normalizedCompany });
    },
    companies: [],
    setCompanies: (companies) => {
        const currentCompanies = get().companies;
        // Tik atnaujiname jei yra naujų įmonių
        if (companies.length > 0 && JSON.stringify(companies) !== JSON.stringify(currentCompanies)) {
            set({ companies });
        } else {
            // Not updating companies - no changes detected
        }
    },

    // Pagrindinių duomenų valdymas
    originalData: {
        atsakymai: [],
        tipai: [],
        atsakymaiTotal: []
    },
    isDataLoaded: false,
    setOriginalData: (data) => {
        const currentState = get();

        // Tikriname ar naujas duomenų rinkinys nėra tuščias
        const hasNewData = data.atsakymai?.length > 0 || data.tipai?.length > 0 || data.atsakymaiTotal?.length > 0;

        if (hasNewData) {
            set({
                originalData: {
                    ...currentState.originalData,
                    ...data
                },
                isDataLoaded: true
            });
        } else {
            // Skipping update - no valid data provided
        }
    },
    clearData: () => set({ 
        originalData: {
            atsakymai: [],
            tipai: [],
            atsakymaiTotal: []
        },
        // Don't clear companies - they should persist
        // companies: [],
        selectedCompany: null,
        isDataLoaded: false 
    })
}));

export default useGlobalData;
